<mwe-wizard [wizardModel]="wizardModel" #wizard>
  <router-outlet (activate)="wizard.onActivate($event, wizardModel)" />
  @if (wizard.currentWizardStepIdx === 1) {
    <mwe-product-add-footer id="wizard-additional-footer" />
  }
</mwe-wizard>
